import { Link, NavLink } from "react-router-dom";
import { isAdmin } from "@common/auth/session";
import type { Session } from "../hooks/useSession";

// The header is the game's, not an app's: brand and page links only. Signing
// in lives in the footer; account and admin links appear once signed in.
export default function Header({ session }: { session: Session }) {
  const { user } = session;
  return (
    <header className="header">
      <Link to="/" className="brand">
        Salvagers
      </Link>
      <nav>
        <a href="/#captains">Captains</a>
        <a href="/#ships">Ships</a>
        <a href="/#art">Art</a>
        <NavLink to="/about">About</NavLink>
        {user && <NavLink to="/account">Account</NavLink>}
        {isAdmin(user) && <NavLink to="/admin">Admin</NavLink>}
      </nav>
      <a className="btn primary small" href={SHOP_URL} target="_blank" rel="noreferrer">
        Buy the game
      </a>
    </header>
  );
}

export const SHOP_URL = "https://www.thegamecrafter.com/games/permalink/CBD1D5DA-48CC-11F0-8057-C92CFC483417";
